export default "__VITE_ASSET__46719607__"